module.exports = __webpack_public_path__ + "img/rpmlogo.02334ca7.png";